import { FlexAlignCenter, FlexBetweenAlignCenter, GenericButton, IconDispatcher } from "shared/ui-basics/index";
import { BenefitCard } from "features/solutions/solutionsComponents/BenefitCard.js";
import { SolutionType } from "@utils/optionsSets/OptionSets";
import { Badge, BadgeWrapper, RemoveButton } from "./PicklistCard_style";
import { useModal } from "use-modal-hook";
import { useSelector } from "react-redux";
import EditSolution from "features/solutions/modals/edit-solution";
import { useTranslation } from "react-i18next";

export const SolutionItemCard = ({ entity, recordId, unlink, disable, index, length, stageId, onClose }) => {
	const { t } = useTranslation();
	const allsolutions = useSelector((state) => state.solutions.all_solutions);
	const currentEntity = entity || allsolutions.find((sol) => sol.id === recordId);
	const [solutionModal] = useModal(EditSolution, { id: recordId || entity?.id, stageId });

	if (!currentEntity)
		return (
			<Badge key={entity?.id} id={entity?.id} disabled={true}>
				<BadgeWrapper index={index} length={length}>
					{t("NO_ACCESS")}
				</BadgeWrapper>
			</Badge>
		);

	const SolutionTypeLabel = () => {
		let labelSolution;
		switch (currentEntity.solutionType) {
			case SolutionType.QuickWin:
				labelSolution = {
					variant: "quickWin",
					icon: "LIKE",
					text: "QUICK_WIN",
				};
				break;
			case SolutionType.NiceToHave:
				labelSolution = {
					variant: "niceToHave",
					icon: "STAR-LIFE",
					text: "NICE_TO_HAVE",
				};
				break;
			case SolutionType.ComplexProject:
				labelSolution = {
					variant: "complexProj",
					icon: "PUZZLE",
					text: "COMPLEX_PROJ",
				};
				break;
			case SolutionType.ToAvoid:
				labelSolution = {
					variant: "toAvoid",
					icon: "ROAD-BARRIER",
					text: "TO_AVOID",
				};
				break;
			default:
				return null;
		}
		return <BenefitCard classes={"px-2 mx-2"} isActive={true} variant={labelSolution.variant} icon={labelSolution.icon} text={labelSolution.text} />;
	};

	const handleClick = (e) => {
		e.stopPropagation();
		if (onClose) {
			onClose();
		}
		if (solutionModal) solutionModal();
	};
	const handleRemove = (e) => {
		e.stopPropagation();
		e.preventDefault();
		unlink(currentEntity?.id);
	};

	return (
		<Badge key={currentEntity?.id} id={currentEntity?.id}>
			<BadgeWrapper index={index} length={length}>
				<FlexAlignCenter>
					{IconDispatcher("SOLUTION", "border border-dark rounded-circle p-1 me-2")}
					<div className="ellipsis obj-name px-2" id={currentEntity?.id} onClick={handleClick} title={currentEntity?.name}>
						{currentEntity?.name?.defaultPlaceholder("SOLUTION_NAME")}
					</div>
				</FlexAlignCenter>

				<FlexBetweenAlignCenter className="px-2">
					<div>{SolutionTypeLabel()}</div>
					{!disable && (
						<RemoveButton>
							<GenericButton variant="light-link" size="xs" id={currentEntity?.id} icon="X" className="p-0" iconClassName="p-0" onClick={handleRemove} />
						</RemoveButton>
					)}
				</FlexBetweenAlignCenter>
			</BadgeWrapper>
		</Badge>
	);
};
